import { Location } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as momentJalaali from 'moment-jalaali';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { ReportContext, ReportDefinition } from '../../report.models';
import { RouteAnalysisRow } from '../route-function-report/route-analysis-report/route-analysis-report.models';
import { RouteAnalysisTableComponent } from '../route-function-report/route-analysis-report/route-analysis-table.component';
import { WorkConfirmation } from '../vehicle-work-report/vehicle-work-report.models';
import { GeofenceSummaryReportApiService } from './geofence-summary-report-api.service';
import { GeofenceSummaryRange, GeofenceSummaryResponse, GeofenceSummaryRow } from './geofence-summary-report.models';
import { GEOFENCE_SUMMARY_COLUMNS, matchesGeofenceSummary } from './geofence-summary-report.utils';
declare const $: { confirm(options: WorkConfirmation): void };
@Component({ selector: 'app-geofence-summary-report', templateUrl: './geofence-summary-report.component.html' })
export class GeofenceSummaryReportComponent implements OnChanges, OnDestroy {
  @Input() context!: ReportContext;
  @Input() definition!: ReportDefinition;
  @ViewChild(RouteAnalysisTableComponent) table?: RouteAnalysisTableComponent;
  rows: GeofenceSummaryRow[] = [];
  selectedKeys: string[] = [];
  readonly columns = GEOFENCE_SUMMARY_COLUMNS;
  readonly searchMatcher = matchesGeofenceSummary;
  readonly form = new FormGroup({ strSDate: new FormControl('', Validators.required), strEDate: new FormControl('', Validators.required) });
  loading = false;
  hasError = false;
  errorMessage = '';
  hasRequestedData = false;
  filtersOpen = true;
  loadedRange?: GeofenceSummaryRange;
  private version = 0;
  private destroyed = false;
  constructor(private readonly api: GeofenceSummaryReportApiService, private readonly guard: GurdServiceService,
    private readonly notify: NotificationService, private readonly other: OtherService, private readonly router: Router,
    private readonly location: Location) {}
  get tableKey(): string { return `geofence-summary-${this.context.id}`; }
  get subtitle(): string { const range = this.loadedRange ?? this.form.getRawValue(); return `از تاریخ ${range.strSDate} الی ${range.strEDate}`; }
  ngOnChanges(): void {
    if (!this.context || !this.definition) return;
    ++this.version; this.loading = false; this.rows = []; this.selectedKeys = []; this.loadedRange = undefined; this.hasError = false; this.hasRequestedData = false; this.filtersOpen = true;
    this.form.enable({ emitEvent: false }); const today = momentJalaali().format('jYYYY/jMM/jDD'); this.form.reset({ strSDate: today, strEDate: today }); this.table?.reset();
  }
  ngOnDestroy(): void { this.destroyed = true; ++this.version; }
  toggleFilters(): void { if (!this.loading) this.filtersOpen = !this.filtersOpen; }
  goBack(): void { this.location.back(); }
  private get credentials() { return { iSystemUser: this.guard.decrypt(localStorage.getItem('ID')!), strSession: this.guard.decrypt(localStorage.getItem('Session')!) }; }
  private accept(result: GeofenceSummaryResponse, report?: string): void {
    if (Array.isArray(result)) return;
    if (result.ISSessionExpired || result.ISessionExpired) { this.notify.showError('لطفا وارد سیستم شوید'); this.other.removeLocalStorage(); void this.router.navigate(['login'], report ? { queryParams: { report } } : undefined); throw new Error('نشست کاربری منقضی شده است'); }
    if (result.iResult === 0) throw new Error(result.strError || 'عملیات با خطا مواجه شد');
  }
  async loadReport(): Promise<void> {
    if (this.loading || this.destroyed || this.form.invalid) return;
    const range: GeofenceSummaryRange = this.form.getRawValue();
    if (range.strSDate > range.strEDate) { this.notify.showError('تاریخ شروع نباید بعد از تاریخ پایان باشد'); return; }
    const version = ++this.version; this.setLoading(true); this.hasError = false; this.hasRequestedData = true;
    try {
      const result = await this.api.load(this.context.id, range, this.credentials); if (version !== this.version) return; this.accept(result, 'search-summarize');
      if (!Array.isArray(result)) throw new Error(result.strError || 'پاسخ گزارش نامعتبر است');
      this.rows = result; this.selectedKeys = []; this.loadedRange = range;
    } catch (error) { if (version === this.version) { this.rows = []; this.selectedKeys = []; this.hasError = true; this.errorMessage = error instanceof Error ? error.message : 'دریافت اطلاعات ناموفق بود'; } }
    finally { if (version === this.version) this.setLoading(false); }
  }
  selectRow(event: { row: RouteAnalysisRow; checked: boolean }): void {
    const id = event.row['iGeoFence_OriginDestination']; if (this.loading || id == null) return;
    const key = String(id); this.selectedKeys = event.checked ? Array.from(new Set([...this.selectedKeys, key])) : this.selectedKeys.filter(value => value !== key);
  }
  selectAll(checked: boolean): void {
    if (this.loading) return;
    const keys = (this.table?.filteredRows ?? this.rows).map(row => row['iGeoFence_OriginDestination']).filter(id => id != null).map(String);
    this.selectedKeys = checked ? Array.from(new Set([...this.selectedKeys, ...keys])) : this.selectedKeys.filter(key => !keys.includes(key));
  }
  confirmDelete(): void {
    if (this.loading || this.destroyed || !this.selectedKeys.length) return;
    const ids = this.rows.filter(row => this.selectedKeys.includes(String(row.iGeoFence_OriginDestination))).map(row => row.iGeoFence_OriginDestination!).filter(id => id != null);
    const version = this.version;
    $.confirm({ title: 'آیا از حذف اطمینان دارید؟', content: '', type: 'red', buttons: { ok: { text: 'حذف', btnClass: 'btn-danger', keys: ['enter'], action: async () => {
      if (version !== this.version || this.loading || this.destroyed) return;
      const requestVersion = ++this.version; this.setLoading(true);
      try { const result = await this.api.delete(ids, this.credentials); if (requestVersion !== this.version) return; this.accept(result); this.rows = []; this.selectedKeys = []; this.notify.showSuccess('با موفقیت حذف شد'); }
      catch (error) { if (requestVersion === this.version) this.notify.showError(error instanceof Error ? error.message : 'حذف ناموفق بود'); }
      finally { if (requestVersion === this.version) this.setLoading(false); }
    } }, cancel: { text: 'لغو' } } });
  }
  private setLoading(value: boolean): void { this.loading = value; value ? this.form.disable({ emitEvent: false }) : this.form.enable({ emitEvent: false }); }
}
